import { createSelector } from '@ngrx/store';
import { AppState } from 'src/store/appstate';

export const selectAllCardLinks = (state: AppState) => state.entityStores.cardLink.entities;

export function selectCardLinkById(id: string) {
  return createSelector(selectAllCardLinks, (cardLink) => cardLink.get(id));
}

export function selectCardLinksByRendezvousRequestId(rendezvousRequestId: string) {
  return createSelector(selectAllCardLinks, (cardLinks) =>
    cardLinks
      .valueSeq()
      .filter((c) => c.rendezvousRequestId === rendezvousRequestId)
      .sortBy((c) => c.toCardNumber),
  );
}
